import Preinvite from './Preinvite.svelte';
// import Register from './Register.svelte';
// import OpenRegistration from './OpenRegistration.svelte';
export const SignUpComponent = Preinvite;
export const ShowName = '2022 iWeek';
export const TopBarTitle = '2022 iWeek';
export const AskQuestionEnabled = true;
export const LivePollEnabled = false;
export const ReactionsEnabled = true;
export const SignUpHeader = "CREATE YOUR 2022 IWEEK ACCOUNT";
export const SignUpDesc = "To create an account please enter your e-mail address below.";
export const SignInHeader = "SIGN INTO YOUR 2022 IWEEK ACCOUNT";
export const SignInDesc = "Welcome back to 2022 iWeek! Please sign in for access to our event.";
export const NavLinks = [
    { name: 'Home', icon: 'home', to: '/' },
    { name: 'Main Stage', icon: 'play_arrow', to: '/stage' },
    { name: 'Schedule', icon: 'schedule', to: '/schedule' },
    { name: 'Winners Archive', icon: 'emoji_events', to: '/winners' }
    // {name: 'Speaker Bios', icon: 'groups', to: '/speakers'},
    // {name: 'Guest Presenter Bios', icon: '/img/icon-assets.svg', to: '/assets/bios'}
];
